<template>
  <div>
    <div
      :style="
        $route.query.newsTop === 'setDsTopBanner'
          ? 'background: #f3f0f0c7;'
          : ''
      "
      @scroll="scrollEvent"
    >
      <div class="Ad-top" v-if="$route.query.newsTop === 'setDsTopBanner'">
        <div class="Ad-top-img">
          <img
            class="Ad_ds_top_header"
            src="@/assets/ds_img/bg_header_hall.png"
            alt=""
          />
          <img
            class="Ad_ds_top_logo"
            src="@/assets/ds_img/logo_100.png"
            alt=""
          />
          <img
            class="Ad_ds_top_title"
            src="@/assets/ds_img/banner_title.png"
            alt=""
          />
          <img
            class="Ad_ds_top_lion"
            src="@/assets/ds_img/header_lion.png"
            alt=""
          />
        </div>
      </div>
      <div class="Ad-top-sq" v-if="$route.query.newsTop === 'setSqTopBanner'">
        <div class="Ad-top-img-sq">
          <img
            class="Ad_ds_top_title_sq"
            src="@/assets/sq_img/header_title.png"
            alt=""
          />
          <img
            class="Ad_ds_top_title_banner"
            src="@/assets/sq_img/banner.png"
            alt=""
          />
          <img
            class="Ad_ds_top_title_people"
            src="@/assets/sq_img/title_people.png"
            alt=""
          />
          <img
            class="Ad_ds_top_title_gezi"
            src="@/assets/sq_img/title_gezi.png"
            alt=""
          />
          <img
            class="Ad_ds_top_title_house"
            src="@/assets/sq_img/title_house.png"
            alt=""
          />
        </div>
      </div>

      <div class="Ad-top1" v-if="$route.query.newsTop === 'bh'">
        <div class="Ad-top-img1">
          <img
            class="Ad_ds_top_title_sq1"
            src="@/assets/bh_img/bh_banner.png"
            alt=""
          />
        </div>
      </div>

      <main class="mainBox Ad-all">
        <router-view></router-view>
      </main>
      <div class="Ad-bottom">
        <p v-if="$route.query.newsTop === 'setDsTopBanner'">
          党史学习教育官方网站
          <a
            href="http://dangshi.people.com.cn"
            style="color: #e02020; margin-left: 36px"
            target="_blank"
          >
            http://dangshi.people.com.cn
          </a>
        </p>
        <p>主办单位：安徽省高校网络思想政治工作中心</p>
        <p>技术支持：安徽力瀚科技有限公司</p>
        <p>
          为了获得更好的使用体验，建议使用谷歌Chrome浏览器或360极速浏览器访问本系统
        </p>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {};
  },
  created() {},
  methods: {
    scrollEvent(e) {
      console.log(e);
    }
  }
};
</script>

<style>
body {
  margin: 0;
  padding: 0;
  background-color: #f2f2f2;
}

.Ad-all {
  width: 1280px;
  height: 100%;
  margin: 0 auto;
  font-family: STHeiti;
  background-repeat: no-repeat;
  background-position: 0px 1032px;
}

.Ad-all .mainBox {
  min-height: calc(100% - 484px);
}

.Ad-top {
  height: 470px;
  background-image: url(../../assets/ds_img/bannerTop_ds.png);
  background-size: 3px 470px;
}
.Ad-top1 {
  height: 300px;
  /* background-image: url(../../assets/ds_img/bannerTop_ds.png); */
  background-size: 3px 470px;
}
.Ad-top-img {
  width: 1280px;
  height: 100%;
  margin: 0 auto;
  /* background-image: url(../../assets/ds_img/banner_top_bg.png); */
  background-size: 101% 470px;
  background-position-x: center;
  position: relative;
}
.Ad-top-img1 {
  width: 1280px;
  height: 100%;
  margin: 0 auto;
  /* background-image: url(../../assets/ds_img/banner_top_bg.png); */
  background-size: 101% 470px;
  background-position-x: center;
  position: relative;
}
.Ad_ds_top_lion {
  position: absolute;
  right: 0px;
  bottom: 0px;
  width: 830px;
  height: 290px;
}
.Ad_ds_top_title {
  position: absolute;
  left: 404px;
  top: 200px;
  width: 522px;
  height: auto;
}
.Ad_ds_top_header {
  position: absolute;
  left: 250px;
  top: 0px;
  width: 1002px;
  height: auto;
}
.Ad_ds_top_logo {
  position: absolute;
  left: 45px;
  top: 120px;
  width: 300px;
  height: auto;
}

.Ad-top-sq {
  height: 470px;
  background-image: url(../../assets/sq_img/bg_header.png);
  background-repeat: no-repeat;
  background-size: 100% 470px;
}

.Ad-top-img-sq {
  width: 1280px;
  height: 100%;
  margin: 0 auto;
  /* background-image: url(../../assets/sq_img/bg_header_center.png); */
  background-size: 101% 470px;
  background-position-x: center;
  position: relative;
}

.Ad_ds_top_title_sq1 {
  width: 101.2%;
  height: 100%;
}
.Ad_ds_top_title_sq {
  position: absolute;
  left: 132px;
  top: 96px;
  width: 752px;
  height: auto;
}
.Ad_ds_top_title_banner {
  position: absolute;
  left: 0;
  bottom: 0;
  width: 100%;
  height: 250px;
  z-index: 100;
}
.Ad_ds_top_title_people {
  position: absolute;
  right: 0;
  bottom: 0;
  width: 540px;
  height: 318px;
  z-index: 50;
}
.Ad_ds_top_title_gezi {
  position: absolute;
  right: 250px;
  top: 0;
  width: 387px;
  height: 330px;
}
.Ad_ds_top_title_house {
  position: absolute;
  left: 0;
  bottom: 0;
  width: 1020px;
  height: 320px;
}
.Ad-bottom {
  min-height: 92px;
  border-top: 4px solid #e02020;
  text-align: center;
  font-size: 18px;
  color: #666666;
  letter-spacing: -0.2px;
  text-align: center;
  line-height: 14px;
  font-weight: 400;
  padding: 35px 0;
}
.Ad-bottom p {
  line-height: 34px;
}
</style>



// WEBPACK FOOTER //
// src/components/content/idnex.vue